import {HttpEvent, HttpHandler, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import { url } from 'inspector';

@Injectable({
    providedIn: 'root'
})
export class ApiPrefixInterceptorService {

    constructor() {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const requestArray = request.url.split('/');
        if (request.url === 'itrl/Search/SearchCashAndFuture' ||
            request.url === 'itrl/Search/SearchOptionsScripSymbol' ||
            request.url === 'itrl/Search/SearchOptionsByScripSymbol' ||
            request.url === 'itrl/Search/OptzSearchOptionsByScripSymbol' ||
            request.url === 'auth/Token/GetAPIAccessKey' ||
            request.url === 'kb/Internal/CheckOrderMargin') {
            request = request.clone({
                url: environment.searchUrl + request.url
            });
        } else if(request.url === "ShareURL/GetShortUrl"){
            request = request.clone({
                url:  environment.docUrl + request.url
            }); 
        } else if (requestArray[0] === 'Research') {
            request = request.clone({
                url: environment.ipobaseUrl + request.url
            });
        } else if(request.url.includes('auth/api/token/GetAPIAccessKey') || request.url.includes('auth/api/login/GenerateOTP') || request.url.includes('auth/api/login/VerifyOTP') || request.url.includes('auth/api/login/SetupMPIN') || request.url.includes('auth/api/login/VerifyMPIN') || request.url.includes('auth/api/user/LogoutV1')){
            request = request.clone({
              // url: request.url
              url: environment.jarvisBaseURL + request.url
            });
          }
        
        
        else {
            request = request.clone({
                url: environment.baseUrl + request.url
            });
        }
        return next.handle(request);
    }

}
